import { ProduceBackupManager } from '@src/slide/application/service/produce-backup-manager/core/base';
import { IMobileProduceBackupManager } from '@src/slide/application/service/produce-backup-manager/core/produce-backup-manager.interface';
import { removeURLParameter, updateQueryStringParameter } from '@src/slide/infrastructure/module/independent/url/param-operation';
import Toast from '@tencent/dui-mobile/lib/components/Toast';
import i18n from '@i18next/i18n';
import tdocsBridge from '@src/slide/infrastructure/module/independent/tdocsBridge/tdocsBridge';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import userLocalStorage, { LocalStorageKeys } from '@src/slide/infrastructure/module/independent/local-storage';
import { openUrlForAll } from '@src/slide/infrastructure/module/independent/url/open-url';

declare global {
    interface Window {
        isMiniProgram?: boolean;
    }
}

export type Item = {
    localPadId?: string;
    domainId?: string;
    type: 'ADD';
    data: Item;
};

export class MobileProduceBackupManager extends ProduceBackupManager implements IMobileProduceBackupManager {
    protected readonly shouldReport = false;

    public redirectToDoc = (url) => {
        if (window.isMiniProgram) {
            window.wx.miniProgram.redirectTo({
                url: `/pages/detail/detail?url=${encodeURIComponent(url)}`,
            });
        } else if (typeof tdocsBridge.tdocsUi?.openUrl === 'function') {
            // 目前来看一直为true，使用openUrl的传参也发生了变更
            // tdocsBridge.tdocsUi.openUrl(config.supportEnterprise(EnterPriseType.ALL)
            //     ? { url, target: 1 }
            //     : { url, target: 0, style: 1 });
            tdocsBridge.tdocsUi?.openUrl({
                url,
                target: 1,
                needPushReplacement: false,
            });
        } else {
            openUrlForAll({
                url,
                replace: true,  // 解决某些浏览器不跳转问题
                windowName: '_blank',
            });
        }
    };

    protected handleCheckBack = () => {
        Toast.show({
            content: i18n.t('已生成并打开副本'),
        });
        // 去掉url上的 newPad 和 newPadType 参数
        try {
            const tempUrl = removeURLParameter(window.location.href, 'newPad');
            const url = removeURLParameter(tempUrl, 'newPadType');
            history.replaceState(null, '', url);
        } catch (e) {
            window.log?.err(e);
        }
    };


    protected handleCreateDocNew = (res) => {
        const title = this.getTitle();
        try {
            this.setLocalActions('ADD', {
                domainId: res.doc_id.domain_id,
                localPadId: res.doc_id.pad_id,
                padType: SlideDataServices.DocInfoManager()?.padType,
                title: res.title || i18n.t('副本-{0}', { 0: title }),
                url: res.doc_url,
                list_item_type: 1,
            });
            this.singleSnackbar.close();
        } catch (error) {
            this.singleSnackbar.show({
                message: i18n.t('生成副本失败，请稍后重试'),
                type: 'error',
                autoClose: true,
            });
        }

        const disableReturnList = document.referrer
            && document.referrer.indexOf(`//${window.hostname}/desktop/m/index.html`) !== -1;
        // eslint-disable-next-line no-useless-escape
        let url = res.doc_url.replace('\/', '/');
        if (!this.injectable.enabledMultipleDomainsFeature) {
            url = url.startsWith('https://') ? url : `https:${url}`;
        }
        url = updateQueryStringParameter(url, {
            newPad: 1,
            newPadType: 'clone',
            disableReturnList: disableReturnList ? 1 : 0,
        });
        this.redirectToDoc(url);
    };

    private setLocalActions = (type, data) => {
        data.createdDate = +(new Date());

        const localData = userLocalStorage.getItem(
            LocalStorageKeys.DOCS_ACTIONS,
            [],
        );

        const mappings = {}; // 使用mapping做去重
        localData.forEach((item, i) => {
            mappings[`${item.localPadId}$${item.domainId}`] = {
                index: i,
                value: item,
            };
        });
        const obj = mappings[`${data.localPadId}$${data.domainId}`];
        // 不存在则添加上去
        if (!obj) {
            localData.push({
                type: 'ADD',
                data,
            });
        } else {
            // 存在则更新, 因为push是往后面加，所以这里的index还是一致的
            localData[obj.index] = {
                type: obj.value === 'ADD' && type === 'MODIFY' ? 'ADD' : type,
                data: obj.value,
            };
        }
        userLocalStorage.setItem(LocalStorageKeys.DOCS_ACTIONS, localData);
    };
}
